

import React from 'react';
import { withRouter } from 'react-router-dom';
import { AuthorisationConsumer } from '../../AuthorisationWrapper';
import RequestProvider from '../../RequestProvider';
import { getContractProductsQuery, getOrgMembershipQuery } from '../queries';
import SubscriptionNotificationComponent from '../components/SubscriptionNotification';







function SubscriptionNotification(props) {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } }) =>
      <RequestProvider
        requests={{
          getContractProducts: getContractProductsQuery(),
          getOrgMembership: getOrgMembershipQuery()
        }}>

          {(requests) =>
        <SubscriptionNotificationComponent
          organisationId={organisationId}
          {...requests}
          {...props} />}


        </RequestProvider>}


    </AuthorisationConsumer>);

}

export default withRouter(SubscriptionNotification);